import React from 'react'

const GreenLeaf = ({color}) => {
  const style = {
    fill: '#fff',
    stroke: color ? color : '#6ec18a',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeMiterlimit: 10,
    strokeWidth: '1.26px',
  }
  return (
    <svg viewBox="0 0 27.033 27.033">
      <g id="Group_9-green-leaf" dataname="Group 9-green-leaf" transform="translate(0.016 0.017)">
        <path
          id="Stroke_1-green-leaf"
          dataname="Stroke 1-green-leaf"
          style={style}
          d="M3.008,18.172c3.835,3.834,9.856,4.028,13.451.434C23.836,11.23,20.364.816,20.364.816S9.95-2.656,2.573,4.721C-1.02,8.316-.826,14.337,3.008,18.172Z"
          transform="translate(5.207 0.614)"
        />
        <path
          id="Stroke_3-green-leaf"
          dataname="Stroke 3-green-leaf"
          style={style}
          d="M3.682,3.682.368,3.314,0,0"
          transform="translate(16.568 6.75)"
        />
        <path
          id="Stroke_5-green-leaf"
          dataname="Stroke 5-green-leaf"
          style={style}
          d="M6.136,6.136,1.314,4.822,0,0"
          transform="translate(10.432 10.432)"
        />
        <path
          id="Stroke_7-green-leaf"
          dataname="Stroke 7-green-leaf"
          style={style}
          d="M20.864,0,0,20.864"
          transform="translate(0.614 5.523)"
        />
      </g>
    </svg>
  )
}

export default GreenLeaf
